import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { SvgLogoRoot } from './SvgLogo.styles';
export var SvgLogo = forwardRef(function (props, ref) {
    var aspectRatio = props.aspectRatio, _a = props.breathingSpace, breathingSpace = _a === void 0 ? 0 : _a, otherProps = __rest(props, ["aspectRatio", "breathingSpace"]);
    return React.createElement(SvgLogoRoot, __assign({ aspectRatio: aspectRatio, breathingSpace: breathingSpace }, otherProps, { ref: ref }));
});
SvgLogo.displayName = 'SvgLogo';
//# sourceMappingURL=SvgLogo.js.map